import { Instance } from 'mobx-state-tree'
import { RecursiveRemoveUndefined } from '../../utils'
import { MessageContractModelBase } from './MessageContractModel.base'

/* The TypeScript type of an instance of MessageContractModel */
export interface MessageContractModelType extends RecursiveRemoveUndefined<Instance<typeof MessageContractModel>> {}

/* A graphql query fragment builders for MessageContractModel */
export {
  selectFromMessageContract,
  messageContractModelPrimitives,
  MessageContractModelSelector
} from './MessageContractModel.base'

/**
 * MessageContractModel
 */
export const MessageContractModel = MessageContractModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
